import { Component } from '@angular/core';

@Component({
  selector: 'app-conference-eligibility-dashboard',
  templateUrl: './conference-eligibility-dashboard.component.html',
  standalone: false
})
export class ConferenceEligibilityDashboardComponent {
}
